'use client'

import { useSession } from '@/lib/auth-client'

import HeaderCta from '@/components/HeaderCta'
import HeaderCtaFallback from '@/components/HeaderCtaFallback'

/**
 * Client component that checks the session and renders the appropriate header CTA.
 * Uses client-side session fetch to avoid headers() which forces all pages to be dynamic.
 */
export default function HeaderCtaLoader() {
  const { data: session, isPending } = useSession()

  if (isPending) return <HeaderCtaFallback />

  return <HeaderCta initialSignedIn={!!session} userName={session?.user?.name || undefined} />
}
